import React from 'react';
import { connect } from 'react-redux';
import BaseComponent from '../../../baseClasses/BaseComponent';
import Home from '../../../containers/Home';
import animator from '../../../helpers/animator';
import ExpandableSection from '../../../components/ExpandableSection';
import ProjectListItem from './ProjectListItem';
import projectsIcon from '../../../assets/images/projects-icon-gray.svg';
import offlineCloudIcon from '../../../assets/images/offline-cloud-double-slash.svg';
import dataModel from '../../../models/DataModel';

import toggle from '../../../assets/images/ao-toggle-on.png';
import './ProjectsList.scss';
import LoadingDots from '../../../components/LoadingDots';

export class ProjectsList extends BaseComponent {

  constructor(props) {
    super(props);
    this.animator = new animator();
    this.state = {
      scrollPosition: 0,
      loadingMore: false,
    };
    this.handleClickScroll = this.handleClickScroll.bind(this);
  }

  componentDidMount() {
    var scrollPosition = localStorage.getItem('scrollPosition');
  
    if (this.scrollContainer) {
      this.scrollContainer.scrollTop = scrollPosition;
      this.scrollContainerTop=  scrollPosition;
    }

  }

  componentWillUnmount() {
  }

  componentDidUpdate(prevProps) {
    if (this.scrollContainer) {

      this.scrollContainer.scrollTop = this.scrollContainerTop;
    }

  }

  alphabetizeProjectList(projectComponentList) {
    projectComponentList.sort((project1, project2) => {
      return project1.props.name > project2.props.name;
    });
  } 

  handleClickScroll(e)  {
    localStorage.setItem('scrollPosition', this.state.scrollPosition);
  };

  createProjectList() {
    const { 
      myProjects, 
      completedProjects,
      handleFavoriteProject,
      handleSelectProject, 
    } = this.props;

    let projects = [];
    const filteredProjects = myProjects && myProjects.projects ? myProjects.projects : [];
    filteredProjects.forEach(project => {
      let listItemComponent;
      if (project) {
        listItemComponent = (
    
          <ProjectListItem 
                    key={project.id}
                    handleClickScroll={this.handleClickScroll}
                    projectExpanded={project}
                    handleFavoriteProject={handleFavoriteProject}
                    handleSelectProject={handleSelectProject}
                    fromPopup={this.props.fromPopup}
                    currentUser={this.props.currentUser}
                  />
        
        );
        projects.push(listItemComponent);
      }
      return null;
    });

    let expandedCompletedProjects;

    if (completedProjects) {
      const completedProjectsArray = [];
      const filteredCompletedProjects = completedProjects && completedProjects.projects ? completedProjects.projects : [];
      filteredCompletedProjects.forEach(project => {
        let completedListItemComponent;
        if (project) {
          completedListItemComponent = (
            <ProjectListItem 
              key={project.id}
              handleClickScroll={this.handleClickScroll}
              projectExpanded={project}
              handleFavoriteProject={handleFavoriteProject}
              handleSelectProject={handleSelectProject}
              fromPopup={this.props.fromPopup}
              currentUser={this.props.currentUser}
            />
          );
          completedProjectsArray.push(completedListItemComponent);
        }
        return null;
      });

      if (completedProjectsArray.length > 0) {
        expandedCompletedProjects = <ExpandableSection name={'Completed Projects (' + completedProjectsArray.length + ')'} initiallyExpanded={this.props.expandCompleted}>
          <div className="">
            {completedProjectsArray}
          </div>
        </ExpandableSection>;
      }
  
    }
    
    return (
      <div className={'project-list-container'}>
        {projects}
        {expandedCompletedProjects}
      </div>
    );
  }

  handleClick(e) {
    if (this.props.fromPopup) {
    }
     
  }

  handleScroll(e) {
    const { myProjects } = this.props;
    const scrollContainer = e.target;
    this.scrollContainerTop = scrollContainer.scrollTop;
    this.setState({
      scrollPosition: this.scrollContainerTop,
    });
    if (Math.ceil(this.scrollContainerTop + scrollContainer.clientHeight) >= scrollContainer.scrollHeight
      && myProjects.projects.length < myProjects.totalProjects
      && !this.state.loadingMore) {
      this.setState({ loadingMore: true }, async() => {
        await this.props.handleLoadMore();
        this.setState({ loadingMore: false });
      });
    }
  }

  render() {

    const { myProjects, completedProjects } = this.props;
    const { loadingMore } = this.state;

    if(dataModel.isOffline && myProjects && myProjects.projects){
      myProjects.projects.sort(function(a,b){
        var x = a && a.is_favorite?  a.is_favorite.toString():'';
        var y = b && b.is_favorite?  b.is_favorite.toString():'';
        var aname=a && a.name?  a.name:'';
        var bname=b && b.name?  b.name:'';

        const projectCompare =  y.localeCompare(x);
        if (projectCompare == 0) {
          return aname.toLowerCase().localeCompare(bname.toLowerCase());
        }
        return projectCompare;
      });  
    }
    
    if (!myProjects) {
      return (
        <div className={'projects-projects-list' + (this.props.fromPopup ? ' from-popup' : '') + (dataModel.mobileBridge.isMobile ? ' is-mobile': '')}>
          <Home type={'projects'} message={'Awaiting Initialization'} timeout={120000} />
        </div>
      );
    }

    let display = this.createProjectList();

    if (this.props.fromPopup && myProjects && myProjects.projects && completedProjects && completedProjects.projects &&
      myProjects.projects.length == 0 && completedProjects && completedProjects.projects.length == 0) {
      display = (
          <div className="project-list-container from-popup">
            <p className="empty-projects__description from-popup">No projects found for this location.</p>
          </div>
        );
    }
    else if (myProjects.projects.length == 0 && !this.props.fromPopup) {
      if (!dataModel.isOffline) {
        display = (
            <div className="project-list-container">
              <img className="empty-projects__image" src={projectsIcon} alt="empty projects" />
              <p className="empty-projects__description">No Projects Found</p>
              <p className="empty-projects__description"></p>
              <p className="empty-projects__description2">Looking for something?</p>
              <p className="empty-projects__description2">Select &#9733; to Favorite a Project and make it available offline.</p>
            </div>
          );
      }
      else {
        display = (
          <div className="project-list-container">
            <img className="empty-projects__image" src={offlineCloudIcon} alt="empty projects" />
            <p className="empty-projects__description">Some results may be unavailable in Offline Mode</p>
          </div>
        );
      }
    }
    
    return (

      <div className={'projects-projects-list' + (this.props.fromPopup ? ' from-popup' : '') + (dataModel.mobileBridge.isMobile ? ' is-mobile': '')}
          ref={el => this.scrollContainer = el} onScroll={this.handleScroll} onClick={this.handleClick}>
        {display}
        {
          loadingMore &&
          <div className='loading-more-indicator'>
            <LoadingDots />
          </div>
        }
      </div>
    );
  }

}

const mapStateToProps = (state) => {
  return {
    inProgress: state.main.inProgress, 
    permissions: state.new_users ? state.new_users.permissions : null, 
    currentUser: state.new_users ? state.new_users.currentUser : null,
    currentCompany: state.new_companies ? state.new_companies.currentCompany : null, 
    online: state.main.online,
  };
};

export default connect(mapStateToProps)(ProjectsList);



// WEBPACK FOOTER //
// ./src/mobileWrappers/ProjectsListWrapper/ProjectsList/index.js